import React from 'react';
import { Box, IconButton, SwipeableDrawer, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { CenteredFlexBox } from '../FlexBox';

/**
 * The mobile bottom sheet: grabber, then the title (a small caption, or a heading with a close
 * button when `closable`), then the children.
 */
const BottomSheet = function BottomSheet({
  open = false,
  onClose = () => {},
  title = '',
  closable = false,
  maxHeight = '76%',
  children = null,
}) {
  const theme = useTheme();

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onOpen={() => {}}
      onClose={onClose}
      disableSwipeToOpen
      sx={{
        '& .MuiDrawer-paper': {
          borderRadius: theme.custom.mobile.sheetRadius,
          maxHeight,
        },
      }}
    >
      <Box
        sx={{
          flex: 'none',
          width: 40,
          height: 5,
          borderRadius: 3,
          bgcolor: '#d5dbe3',
          m: '8px auto 6px',
        }}
      />
      {closable ? (
        <CenteredFlexBox
          sx={{ flex: 'none', justifyContent: 'space-between', px: 2, pb: 0.5 }}
        >
          <Typography sx={{ fontSize: 18, fontWeight: 700 }}>
            {title}
          </Typography>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseRoundedIcon />
          </IconButton>
        </CenteredFlexBox>
      ) : (
        <Typography
          sx={{
            flex: 'none',
            px: 2.5,
            py: 1,
            fontSize: 13,
            fontWeight: 700,
            textTransform: 'uppercase',
            color: theme.custom.mobile.mutedColor,
          }}
        >
          {title}
        </Typography>
      )}
      {children}
    </SwipeableDrawer>
  );
};

export default BottomSheet;
